import { Fragment } from "react";

// MUI
import { Box, Grid, IconButton, Typography } from "@mui/material";

// Icons
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

export default function ActivityDataDialog(props) {
	const handleClose = () => {
		props.closeCallback();
	};

	const renderData = (data) => {
		const formatKey = (key) => {
			// Split the key by capital letters or underscore
			const words = key.split(/(?=[A-Z])|_/);
			// Capitalize the first letter of each word and join them with spaces
			return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
		};

		return Object.entries(data).map(([key, value]) => {
			if (value !== null && typeof value === "object") {
				/* <Typography className="select-plan-dialog-employee-data-title">{key}</Typography> */

				return <Fragment key={key}>{renderData(value)}</Fragment>;
			}
			if (typeof value === "string") {
				return (
					<Box key={key} component="div" className="activity-data-dialog-content">
						<Typography className="activity-data-dialog-content">
							<strong>{`${formatKey(key)}:`}</strong>
						</Typography>
						<Typography
							className="activity-data-dialog-content"
							component="div"
							dangerouslySetInnerHTML={{
								__html: `${value}`,
							}}
						/>
					</Box>
				);
			}
			return null;
		});
	};

	return (
		<Grid container direction="column" className="!p-6">
			<Grid item>
				<IconButton aria-label="close" className="!absolute !top-[10px] !right-[10px]" onClick={handleClose}>
					<CloseRoundedIcon />
				</IconButton>
				<Grid container direction="column">
					<Grid item sx={{ marginBottom: "20px" }}>
						<Typography className="header-label-dialog">{`Activity Type: ${props?.data?.activityType}`}</Typography>
					</Grid>
					{Object.entries(props?.data).map(([key, value]) => {
						if (value !== null && key.includes("Data") && typeof value === "object") {
							return (
								<Grid container direction="row" key={key}>
									<Grid item>{renderData(value)}</Grid>
								</Grid>
							);
						}
						return null;
					})}
				</Grid>
			</Grid>
		</Grid>
	);
}
